import React from 'react';

import './ProductCount.css';

interface ProductCountProps {
    count: number;
}

export function ProductCount({ count }: ProductCountProps) {
    const label = count === 1 ? 'product total' : 'products total';
    return (
        <span className="ats-product-count">
            {count} {label}
        </span>
    );
}
